<script>
import LoginModal from "@/components/modal/login-modal.vue";
import {ref} from "vue";

export default {
  components: {
    LoginModal,
  },
  setup() {
    const showModal = ref(false);

    return {
      showModal
    }
  }
};
</script>

<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view/>
    </div>
  </div>
  <LoginModal/>
</template>